module.exports = __webpack_public_path__ + "8f2e831add106cf8ee64b86d525df87b.svg";